import { AuthenticationState, initialAuthenticationState } from "./authentication/authentication.state";
import { ClipboardState, initialClipboardState } from "./clipboard/clipboard.state";
import { DataState, initialDataState } from "./data/data.state";
import { NotificationState, initialNotificationState } from "./notification/notification.state";
import { SettingsState, initialSettingsState } from "./settings/settings.state";

// **************************************************************************
// APPLICATION STORE
// Infrastructure state (auth, clipboard, data, settings, notification)
// User and Navigation are standalone stores
// **************************************************************************
export interface ApplicationStore {
    authentication: AuthenticationState;
    clipboard: ClipboardState;
    data: DataState;
    settings: SettingsState;
    notification: NotificationState;
}

export const initialApplicationStore: ApplicationStore = {
    authentication: initialAuthenticationState,
    clipboard: initialClipboardState,
    data: initialDataState,
    settings: initialSettingsState,
    notification: initialNotificationState,
};
